/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Headline boxes + verdict for the Pause → Alert Impact detail page (042).
 *
 * The verdict is stated in words rather than left to be inferred from the numbers
 * (FR-007). `no_baseline` says so explicitly and never borrows the language or the
 * styling of a decrease — it means "there was nothing to compare against", which is
 * an absence of evidence, not a result (FR-008 / SC-005).
 */

const VERDICT = {
  decreased: {
    text: 'Alerts decreased during the pause period',
    tone: 'pai-verdict--good',
    icon: '↓',
  },
  increased: {
    text: 'Alerts increased during the pause period',
    tone: 'pai-verdict--bad',
    icon: '↑',
  },
  unchanged: {
    text: 'No change in alert rate during the pause period',
    tone: 'pai-verdict--flat',
    icon: '→',
  },
  no_baseline: {
    text: 'No baseline to compare against — this user had no alerts in the 30 days before they started pausing',
    tone: 'pai-verdict--unknown',
    icon: '?',
  },
};

const PauseAlertImpactDetailCards = ({ facts }) => {
  if (!facts) return null;

  const verdict = VERDICT[facts.alert_trend] || VERDICT.no_baseline;
  const delta = Number(facts.rate_delta);

  return (
    <>
      <div className={`pai-verdict ${verdict.tone}`} data-testid="pai-verdict">
        <span className="pai-verdict__icon" aria-hidden="true">{verdict.icon}</span>
        <span className="pai-verdict__text">{verdict.text}</span>
      </div>

      <div className="au-cards pai-detail-cards" data-testid="pai-detail-cards">
        <div className="au-card">
          <span className="au-card__label">Breath sessions</span>
          <span className="au-card__value tnum" data-testid="pai-box-breath">{facts.breath_sessions}</span>
          <span className="au-card__hint">Within the pause window</span>
        </div>

        <div className="au-card">
          <span className="au-card__label">Alerts before</span>
          <span className="au-card__value tnum" data-testid="pai-box-before">{facts.alerts_before}</span>
          <span className="au-card__hint">{facts.alerts_per_day_before} / day over 30 days</span>
        </div>

        <div className="au-card">
          <span className="au-card__label">Alerts during</span>
          <span className="au-card__value tnum" data-testid="pai-box-during">{facts.alerts_during}</span>
          <span className="au-card__hint">{facts.alerts_per_day_during} / day</span>
        </div>

        <div className={`au-card ${delta < 0 ? 'pai-good' : delta > 0 ? 'pai-bad' : 'pai-flat'}`}>
          <span className="au-card__label">Rate delta</span>
          <span
            className={`au-card__value tnum ${delta < 0 ? 'pai-delta-down' : delta > 0 ? 'pai-delta-up' : ''}`}
            data-testid="pai-box-delta"
          >
            {facts.rate_delta}
          </span>
          <span className="au-card__hint">Alerts per day, during minus before</span>
        </div>
      </div>
    </>
  );
};

export default PauseAlertImpactDetailCards;
